export default "__VITE_ASSET__CZAyIqrg__"